import { PimProductV1StockStatusEnum } from '@redteclab/api/clients/bully'

export const productAccessorIsProductOutOfStock = (
  stockStatus: PimProductV1StockStatusEnum | null | undefined,
): boolean =>
  !stockStatus ||
  stockStatus === PimProductV1StockStatusEnum.OutOfStock ||
  stockStatus === PimProductV1StockStatusEnum.Service ||
  stockStatus === PimProductV1StockStatusEnum.Variant
